"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _types = require("../types");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function createInitialState() {
  var initialState = {
    values: [],
    byValue: {}
  };
  return initialState;
}

var GroupBy =
/*#__PURE__*/
function () {
  function GroupBy(name, definition) {
    _classCallCheck(this, GroupBy);

    this.name = name;
    this.definition = definition; // Get the aggregations from the definitions

    this.aggrs = [];

    var reducers = _defineProperty({}, _types.POPULATE, this.createPopulate());

    this.reducer = function (state, action) {
      var reducer = reducers[action.type];
      if (!reducer) return state;
      return reducer(state, action);
    };
  }

  _createClass(GroupBy, [{
    key: "createPopulate",
    value: function createPopulate() {
      var _this = this;

      return function (state, action) {
        var records = action.payload;
        var newState = createInitialState();
        records.forEach(function (record) {
          var value = _this.getValue(record);

          var valueInfo = newState.byValue[value];

          if (!valueInfo) {
            valueInfo = {
              ids: [record.id]
            };
            newState.byValue[value] = valueInfo;
            newState.values.push(value);
          }

          valueInfo.ids.push(record.id);

          _this.aggrs.forEach(function (aggr) {
            valueInfo[aggr.name] = aggr.calc(valueInfo[aggr.name], record);
          });
        });
      };
    } // createInsert() {
    //   return (state, action) => {
    //     const record = action.payload;
    //     const value = this.getValue(record);
    //     const newState = state ? Object.assign({}, state) : {
    //       values: [value],
    //       byValue: {
    //         [value]: {
    //           ids: [record.id],
    //         },
    //       },
    //     };
    //     this.aggrs.forEach((aggr) => {
    //       const valueInfo = newState.byValue[value];
    //       const prev = valueInfo[aggr.name];
    //       valueInfo[aggr.name] = aggr.calc(prev, record);
    //     });
    //     return newState;
    //   };
    // }

  }, {
    key: "getReducer",
    value: function getReducer() {
      return this.reducer;
    }
  }]);

  return GroupBy;
}();

exports["default"] = GroupBy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sharingapples/redux/dist/schema/groupBy/index.js
// module id = 1353
// module chunks = 2